import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const path = "advertiser/user";
const options = { role: ROLE.ADVERTISER };

// for advertiser 

export const profileDetails = async (values) => {
  return await axiosInstance(options).get(`${path}/get-seller-details`, { params: values });
}
export const editProfile = async (values) => {
  return await axiosInstance(options).put(`${path}/edit-profile`, values);
};
export const editBusinessProfile = async (values) => {
  return await axiosInstance(options).put(`${path}/edit-business-profile`, values);
};
export const editKyc = async (values) => {
  return await axiosInstance(options).put(`${path}/edit-kyc`, values);
};
export const changePassword = async (values) => {
  return await axiosInstance(options).patch(`${path}/change-password`, values);
};
export const editSocialLinks = async (values) => {
  return await axiosInstance(options).put(`${path}/edit-social-links`, values);
};
export const sendUpdateOtp = async (values) => {
  return await axiosInstance(options).post(`${path}/send-update-otp`, values);
};
export const verifyUpdateOtp = async (values) => {
  return await axiosInstance(options).put(`${path}/verify-update-otp`, values);
};


// for staff 

export const getUsersList = async (params) => {
  return await axiosInstance(options).get(`${path}/get-users-list`, { params });
};
export const searchTeamStaffs = async (params) => {
  return await axiosInstance(options).get(`${path}/search-team-staffs`, { params });
};
export const createStaff = async (values) => {
  return await axiosInstance(options).post(`${path}/create-user`, values);
};
export const editStaff = async (values) => {
  return await axiosInstance(options).put(`${path}/edit-user`, values);
};
export const staffList = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
};
export const getAllStaffs = async () => {
  return await axiosInstance(options).get(`${path}/get-all-staffs`);
};
export const deleteStaff = async (values) => {
  return await axiosInstance(options).delete(`${path}/delete?_id=${values._id}`);
};
export const getStaffDetails = async (params) => {
  return await axiosInstance(options).get(`${path}/details`, { params });
};






